










import {
  defineComponent,
  PropType,
  computed,
  getCurrentInstance,
  watch,
} from '@vue/composition-api';
import NavBarCoffee from '@/components/nav-bar-coffee/index.vue';
import type { ComponentConfig } from '@/pages/activity-home/types';

export default defineComponent({
  name: 'NavBar',
  components: {
    NavBarCoffee,
  },
  props: {
    config: {
      type: Object as PropType<ComponentConfig>,
      required: true,
    },
  },
  setup(props: { config: ComponentConfig }) {
    const instance = getCurrentInstance();
    /** 背景图片URL */
    const backgroundImageUrl = computed(() => props.config.backgroundImage?.default || '');

    /** 监听标题变化，更新 $route.meta.title */
    watch(() => props.config.title, (title) => {
      const currentRoute = instance?.proxy?.$route;
      if (currentRoute) {
        currentRoute.meta.title = title;
      }
    }, { immediate: true });

    return {
      backgroundImageUrl,
    };
  },
});
